import { render, staticRenderFns } from "./MainLoader.vue?vue&type=template&id=494bf581&scoped=true&"
import script from "./MainLoader.vue?vue&type=script&lang=js&"
export * from "./MainLoader.vue?vue&type=script&lang=js&"
import style0 from "./MainLoader.vue?vue&type=style&index=0&id=494bf581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494bf581",
  null
  
)

export default component.exports